import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  getAllGamePosts,
  getAllSearchPosts,
  getAllRelatedPosts,
} from "../src/utils/firebase";
import Video from "./Video";
import VideoStableDuel from "./VideoStableDuel";
import VideoAlt from "./VideoAlt";

function VideoFeedStatic({
  classes,
  title,
  game,
  upload,
  search,
  columns,
  variant,
  stableduel,
}) {
  let feed;
  if (game) {
    feed = getAllGamePosts(game);
  } else if (upload) {
    feed = getAllRelatedPosts(upload);
  } else if (search) {
    feed = getAllSearchPosts(search);
  }

  const [feedLoaded, setFeedLoaded] = useState(false);

  useEffect(() => {
    if (!feedLoaded) {
      setFeedLoaded(true);
    }
  }, [feed]);

  return (
    <div className={classes.feedRoot}>
      <Typography
        variant="h6"
        className={stableduel ? classes.sdFeedTitle : classes.feedTitle}
      >
        {title}
      </Typography>
      <Grid container spacing={3}>
        {!feedLoaded && (
          <Grid item xs={columns || 12} sm={columns || 6} md={columns || 3}>
            <Skeleton variant="rect" height={272} />
          </Grid>
        )}

        {feedLoaded && feed && feed.length == 0 && (
          <p className={classes.emptyFeedText}>
            {user && "This user hasn't uploaded anything yet."}
            {tag && "There are no videos for this tag yet."}
            {game && "There are no videos for this game yet."}
            {upload && "There are no related videos for this video yet."}
            {search && `No videos found for "${search}".`}
          </p>
        )}

        {feedLoaded &&
          feed &&
          feed.length > 0 &&
          feed.map((feedItem, i) => (
            <Grid
              item
              xs={columns || 12}
              sm={columns || 6}
              md={columns || 3}
              key={i}
            >
              {stableduel ? (
                <VideoStableDuel flex video={feedItem} />
              ) : (
                <>
                  {variant === "alt" ? (
                    <VideoAlt flex video={feedItem} />
                  ) : (
                    <Video flex video={feedItem} />
                  )}
                </>
              )}
            </Grid>
          ))}
      </Grid>
    </div>
  );
}

export default VideoFeedStatic;
